import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MasterProductGimmickDetailPage } from './master-product-gimmick-detail.page';

const routes: Routes = [
  {
    path: '',
    component: MasterProductGimmickDetailPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MasterProductGimmickDetailPageRoutingModule {}
